// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrincipalSummary } from './principal-summary';
import {
    PrincipalSummaryFromJSON,
    PrincipalSummaryFromJSONTyped,
    PrincipalSummaryToJSON,
    PrincipalSummaryToJSONTyped,
} from './principal-summary';

/**
 * 
 * @export
 * @interface PrincipalListResponse
 */
export interface PrincipalListResponse {
    /**
     * 
     * @type {string}
     * @memberof PrincipalListResponse
     */
    nextToken?: string;
    /**
     * 
     * @type {Array<PrincipalSummary>}
     * @memberof PrincipalListResponse
     */
    principals: Array<PrincipalSummary>;
}

/**
 * Check if a given object implements the PrincipalListResponse interface.
 */
export function instanceOfPrincipalListResponse(value: object): value is PrincipalListResponse {
    if (!('principals' in value) || value['principals'] === undefined) return false;
    return true;
}

export function PrincipalListResponseFromJSON(json: any): PrincipalListResponse {
    return PrincipalListResponseFromJSONTyped(json, false);
}

export function PrincipalListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrincipalListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
        'principals': ((json['principals'] as Array<any>).map(PrincipalSummaryFromJSON)),
    };
}

export function PrincipalListResponseToJSON(json: any): PrincipalListResponse {
    return PrincipalListResponseToJSONTyped(json, false);
}

export function PrincipalListResponseToJSONTyped(value?: PrincipalListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nextToken': value['nextToken'],
        'principals': ((value['principals'] as Array<any>).map(PrincipalSummaryToJSON)),
    };
}
